import type { Role } from './auth-store';

export type Action = 'view' | 'manage';
export type Resource = 'app';

type Rule = Role[] | 'auth';
type PermissionMap = Record<Resource, Record<Action, Rule>>;

export const PERMISSIONS: PermissionMap = {
  app: {
    manage: ['admin'],
    view: 'auth',
  },
};
